/* tslint:disable:member-access */
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import React from "react";
import "./BB8Stepper.scss";

export type IconTypes = "Processing" | "OnHold" | "Rejected" | "Complete";

const styles = (theme: Theme) =>
  createStyles({
    backButton: {
      marginRight: theme.spacing.unit
    },
    instructions: {
      marginBottom: theme.spacing.unit,
      marginTop: theme.spacing.unit
    },
    root: {
      width: "90%"
    }
  });

const iconFactoryByStatus = (status: IconTypes | null) => {
  switch (status) {
    case "Processing":
      return (
        <div className="bb8-step processing">
          <img
            src={require("../assets/images/bb8-processing-24px.svg")}
            alt="Processing"
          />
        </div>
      );
    case "OnHold":
      return (
        <div id="step-hold" className="bb8-step hold">
          <img
            src={require("../assets/images/bb8-warning-24px.svg")}
            alt="On Hold"
          />
        </div>
      );
    case "Rejected":
      return (
        <div id="step-rejected" className="bb8-step rejected">
          <img
            src={require("../assets/images/bb8-rejected-24px.svg")}
            alt="Rejected"
          />
        </div>
      );
    case "Complete":
      return (
        <div id="step-completed" className="bb8-step completed">
          <img
            src={require("../assets/images/bb8-done-24px.svg")}
            alt="Completed"
          />
        </div>
      );

    default:
      return <div className="bb8-step idle">{}</div>;
  }
};

const BB8Stepper = ({
  steps,
  activeStep,
  classes
}: {
  steps: Array<{
    title: string;
    status: IconTypes | null;
    lastUpdated: any;
  }>;
  activeStep: number;
  classes: any;
}) => {
  return (
    <div id="root-div" className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel={true}>
        {steps.map(({ title, status, lastUpdated }, index) => {
          return (
            <Step id={"step-" + (index + 1)} key={title}>
              <StepLabel icon={iconFactoryByStatus(status)}>
                <div>
                  <div id="title" className="bb8-stepper title">
                    {title}
                  </div>
                  <div id="last-updated-date" className="bb8-stepper">
                    {lastUpdated
                      ? moment(lastUpdated).format("MM/DD/YYYY")
                      : "-"}
                  </div>
                  <div
                    id="last-updated-from-now"
                    className="bb8-stepper last-update"
                  >
                    {lastUpdated ? `(${moment(lastUpdated).fromNow()})` : ""}
                  </div>
                </div>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default withStyles(styles)(BB8Stepper);
